import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

// Import Images
import logolight from "../../../assets/images/logo-light1.png";
import "./scss/footer.scss";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12} className="mt-4">
              <div className="text-center">
                <div>
                  <img src={logolight} alt="logo light" height="57" />
                </div>
                <div className="mt-4 ">
                  <p>
                    Hacemos de tu Administración, Contabilidad y Remuneraciones
                    algo simple. Soluciones a la medida de tus necesidades
                  </p>
                </div>
              </div>
            </Col>

            {/* <Col lg={7} className="ms-lg-auto">
              <Row>
                <Col sm={4} className="mt-4">
                  <h5 className="text-white mb-0">Company</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list">
                      <li>
                        <Link to="/pages-profile">About Us</Link>
                      </li>
                      <li>
                        <Link to="/pages-gallery">Gallery</Link>
                      </li>
                      <li>
                        <Link to="/apps-projects-overview">Projects</Link>
                      </li>
                      <li>
                        <Link to="/pages-timeline">Timeline</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col sm={4} className="mt-4">
                  <h5 className="text-white mb-0">Apps Pages</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list">
                      <li>
                        <Link to="/pages-pricing">Calendar</Link>
                      </li>
                      <li>
                        <Link to="/apps-mailbox">Mailbox</Link>
                      </li>
                      <li>
                        <Link to="/apps-chat">Chat</Link>
                      </li>
                      <li>
                        <Link to="/apps-crm-deals">Deals</Link>
                      </li>
                      <li>
                        <Link to="#">Kanban Board</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col sm={4} className="mt-4">
                  <h5 className="text-white mb-0">Support</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list">
                      <li>
                        <Link to="/pages-faqs">FAQ</Link>
                      </li>
                      <li>
                        <Link to="/pages-faqs">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col> */}
          </Row>

          <Row className="text-center text-sm-start align-items-center mt-5">
            <Col sm={6}>
              <div>
                <p className="copy-rights mb-0">
                  {new Date().getFullYear()} © BackApp Chile
                </p>
              </div>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end mt-3 mt-sm-0">
                <ul className="list-inline mb-0 footer-social-link">
                  <li className="list-inline-item">
                    <Link
                      to="https://www.linkedin.com/company/backapp-chile"
                      className="avatar-xs d-block"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-linkedin-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      to="https://www.instagram.com/backapp_chile"
                      className="avatar-xs d-block"
                    >
                      <div className="avatar-title rounded-circle">
                        <i className="ri-instagram-fill"></i>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
